import React from "react";
import { HubActionDialog } from "../HubActionDialog";

const defaultDescription = `You have unsaved changes, leaving will lose any updates.`;

export const WarningNavigateDialog = ({
  isOpen = false,
  onClose = () => {},
  onSubmit = () => {},
  description = defaultDescription,
  ...rest
}) => {
  return (
    <HubActionDialog
      onClose={onClose}
      open={isOpen}
      title="Unsaved Changes!"
      description={description}
      handleSubmit={onSubmit}
      submitLabel="Accept"
      action="warning"
      {...rest}
    />
  );
};

export default WarningNavigateDialog;
